import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useSelector } from "react-redux";
import { updateConfig } from "../../../store/slices/Delivery/completedDeliverySlice";
import { debounce } from "lodash";
import { subDays } from "date-fns";
import { useLocation } from "react-router-dom";
import {
  useGetCompletedDeliveryListDataQuery,
  useGetCompletedDeliveryRecheckReissueListDataQuery,
  useUpdateDeliveryCompletedTableHeadDataMutation,
} from "../../../store/queries/Delivery";
import { downloadDeliveryExcel } from "../../Employees/Delivery/api";
import {
  getPrintChellan,
  getPrintSlip,
  getOrderPrintChellan,
  getOrderPrintSlip,
  getDeliveryStockReceiptSlip,
  getDeliveryRecheckReissueStockReceiptSlip,
  downloadDeliveryRecheckExcel,
  getMultipleRecheckReissueSlip,
} from "../../EmployeeRecheck/DeliveryRecheck/api";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";
import moment from "moment";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const useDeliveryCompleted = () => {
  const [loadingSlip, setLoadingSlip] = useState(false);
  const [loadingChellan, setLoadingChellan] = useState(false);
  const [loadingStockReceipt, setLoadingStockReceipt] = useState(false);
  const [loadingOfficeSlip, setLoadingOfficeSlip] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSlipIds, setSelectedSlipIds] = useState([]);
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const reduxState = useSelector((state) => state.completedDelivery);
  // eslint-disable-next-line no-unused-vars
  const [date, setDate] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    key: "selection",
  });
  const startDate = new Date(date.startDate).toISOString().split("T")[0];
  const endDate = new Date(date.endDate).toISOString().split("T")[0];
  const initialFormattedDate = [startDate, endDate];
  const [formattedDate, setFormattedDate] = useState(initialFormattedDate);
  const queryState = reduxState?.BillEstimate;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get("activeTab");
  const slipRef = useRef(null);
  const chellanRef = useRef(null);
  const officeSlipRef = useRef(null);
  const stockReceiptRef = useRef(null);
  const dispatch = useDispatch();
  const { tableFields, showEditModal } = useSelector((state) => state.global);

  const queryParams = {
    per_page: queryState?.currentPageSize,
    page: queryState?.currentPage,
    sort_by: queryState?.sortBy,
    sort_order: queryState?.sortOrder,
    search: queryState?.search,
    date: formattedDate,
  };

  const {
    data: orderList = {},
    isLoading: isOrderLoading,
    isFetching: isOrderFetching,
    refetch: refetchOrders,
  } = useGetCompletedDeliveryListDataQuery(queryParams, {
    skip: activeTab !== "orders",
  });

  const {
    data: recheckList = {},
    isLoading: isRecheckLoading,
    isFetching: isRecheckFetching,
    refetch: refetchRecheck,
  } = useGetCompletedDeliveryRecheckReissueListDataQuery(queryParams, {
    skip: activeTab === "orders",
  });

  const deliveryList = activeTab === "orders" ? orderList : recheckList;
  const isLoading = activeTab === "orders" ? isOrderLoading : isRecheckLoading;
  const isFetching =
    activeTab === "orders" ? isOrderFetching : isRecheckFetching;
  const refetch = activeTab === "orders" ? refetchOrders : refetchRecheck;
  console.log("delivery list===", deliveryList?.data?.data);
  const [updateEstimateFields] =
    useUpdateDeliveryCompletedTableHeadDataMutation();

  useEffect(() => {
    dispatch(
      globalUpdateConfig((state) => {
        const fields = deliveryList?.data?.fields
          ? {
              ...deliveryList.data.fields,
              eway_bill_delivery_download: {
                label: "Eway Bill Delivery",
                sortable: false,
              },
            }
          : deliveryList?.data?.fields;
        state.tableFields = fields;
      }),
    );
    // eslint-disable-next-line
  }, [deliveryList]);

  useEffect(() => {
    setSelectedRows([]);
    const updateState = () => {
      return new Promise((resolve) => {
        dispatch(
          updateConfig((state) => {
            state.BillEstimate.activeTab = activeTab;
            state.clearSelection = true;
            state.BillEstimate.clear = true;
          }),
        );
        resolve();
      });
    };
    setSelectedSlipIds([]);
    updateState().then(() => {
      dispatch(
        updateConfig((state) => {
          state.BillEstimate.clear = false;
        }),
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const getReceiptIdFromRow = (row) =>
    row?.receipt_id || row?._id || row?.id || "";

  const handleEwayBillDeliveryDownload = (receiptId) => {
    if (!receiptId) {
      toast.error("Receipt id not found");
      return;
    }
    const downloadFn =
      activeTab === "orders"
        ? downloadDeliveryExcel
        : downloadDeliveryRecheckExcel;
    downloadFn(receiptId, "eway_bill_delivery").then((response) => {
      if (response?.data?.data?.url) {
        const { url, extension } = response.data.data;
        let downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.setAttribute(
          "download",
          `Eway_Bill_Delivery_${moment(Date.now()).format("MM_DD_YYYY_HH_mm_ss")}.${extension}`,
        );
        downloadLink.target = "_blank";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        toast.success("Eway Bill Delivery downloaded successfully.");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    });
  };
  const normalizeSelectedIds = (ids) => {
    const normalizedIds = Array.isArray(ids)
      ? ids.filter(Boolean)
      : ids
        ? [ids]
        : [];

    return normalizedIds.length ? normalizedIds : selectedSlipIds;
  };

  const validateSingleDeliverySelection = (
    ids,
    actionLabel = "this action",
  ) => {
    const selectedIds = normalizeSelectedIds(ids);

    if (!selectedIds.length) {
      toast.error("Please select at least one stock receipt");
      return null;
    }

    if (selectedIds.length > 1) {
      toast.warning(`Please select only one stock receipt for ${actionLabel}`);
      return null;
    }

    return selectedIds;
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      service: (feild, data) => (
        <ul>
          {data[feild]?.map(({ name }, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      ),
      eway_bill_delivery_download: (_, data) => (
        <p className="pro-mb-0">
          <Button
            className={"pro-btn-primary"}
            onClick={() =>
              handleEwayBillDeliveryDownload(getReceiptIdFromRow(data))
            }
          >
            Download
          </Button>
        </p>
      ),
    };
    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      }),
    );
  };
  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.BillEstimate.currentPageSize = page_size;
        state.BillEstimate.currentPage = 1;
      }),
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.BillEstimate.currentPage = page;
      }),
    );
  };

  const handleSort = (label) => {
    if (queryState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.BillEstimate.currentPage = 1;
          state.BillEstimate.sortOrder =
            queryState.sortOrder === "asc" ? "desc" : "asc";
        }),
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.BillEstimate.currentPage = 1;
          state.BillEstimate.sortBy = label;
          state.BillEstimate.sortOrder = "asc";
        }),
      );
    }
  };

  const handleSearchDebounced = debounce((value, dispatch) => {
    dispatch(
      updateConfig((state) => {
        state.BillEstimate.search = value;
        state.BillEstimate.currentPage = 1;
      }),
    );
  }, 1000);

  const handleSearch = (e) => {
    handleSearchDebounced(e.target.value, dispatch);
  };

  const handleDateChange = (date) => {
    const startDateUTC = new Date(date.startDate);
    const endDateUTC = new Date(date.endDate);
    const timeZoneOffset = 5.5 * 60 * 60 * 1000;
    const startDateIST = new Date(startDateUTC.getTime() + timeZoneOffset);
    const endDateIST = new Date(endDateUTC.getTime() + timeZoneOffset);

    const formatDate = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const startDateFormatted = formatDate(startDateIST);
    const endDateFormatted = formatDate(endDateIST);
    const dateArray = [startDateFormatted, endDateFormatted];
    setFormattedDate(dateArray);
  };

  const navigation = [
    {
      label: "Orders",
      title: "Orders",
      link: `/orders/delivery-completed/delivery-work-completed?activeTab=orders`,
      active: queryState?.activeTab === "orders",
    },
    {
      label: "Recheck/Reissue",
      title: "Recheck",
      link: `/orders/delivery-completed/delivery-work-completed?activeTab=recheck`,
      active: queryState?.activeTab === "recheck",
    },
  ];

  const handlePrintSlip = (e) => {
    const stockReceiptIds = normalizeSelectedIds(e);
    if (!stockReceiptIds.length) {
      toast.error("Please select at least one stock receipt");
      return;
    }
    setLoadingSlip(true);
    getMultipleRecheckReissueSlip(stockReceiptIds).then((response) => {
      if (response?.data?.status_code === 200) {
        setLoadingSlip(false);
        dispatch(
          updateConfig((state) => (state.printData = response?.data?.data)),
        );
        toast.success("Delivery Slip downloaded successfully");
      } else {
        setLoadingSlip(false);
        toast.error("Something went wrong");
      }
      const printSlip = () => {
        const element = slipRef?.current;
        html2pdf(element, {
          margin: [2, 2, 2, 2],
          filename: `${response?.data?.data?.gli_number || ""}_Delivery Slip_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: {
            dpi: 100,
            letterRendering: true,
            useCORS: true,
            logging: true,
            scale: 4,
            scrollY: 0,
          },
          jsPDF: { unit: "mm", format: "a5", orientation: "portrait" },
          pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
          DisablePdfCompression: true,
        });
      };
      setTimeout(() => {
        printSlip();
      }, 500);
    });
  };

  const handlePrintChellan = (e) => {
    const selectedIds = validateSingleDeliverySelection(e, "Print Challan");
    if (!selectedIds) {
      return;
    }

    setLoadingChellan(true);
    const id = selectedIds[0];
    getPrintChellan(id).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig(
            (state) => (state.printChellanData = response?.data?.data),
          ),
        );
        setLoadingChellan(false);
        toast.success("Delivery Challan downloaded successfully");
      } else {
        setLoadingChellan(false);
        toast.error("Something went wrong");
      }
      let gliData = deliveryList?.data?.data?.find((item) => item?.id === id);
      const printSlip = () => {
        const element = chellanRef?.current;
        html2pdf(element, {
          margin: [10, 2, 2, 2],
          filename: `${gliData?.gli_number || ""}_Delivery Challan_${gliData?.challan_number || ""}_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: {
            dpi: 100,
            letterRendering: true,
            useCORS: true,
            logging: true,
            scale: 4,
            scrollY: 0,
          },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
          DisablePdfCompression: true,
        });
      };
      setTimeout(() => {
        printSlip();
      }, 500);
    });
  };
  const handleOrderPrintSlip = (e) => {
    setLoadingSlip(true);
    const id = e?.[0];
    getOrderPrintSlip(id).then((response) => {
      if (response?.data?.status_code === 200) {
        setLoadingSlip(false);
        dispatch(
          updateConfig((state) => (state.printData = response?.data?.data)),
        );
        toast.success("Delivery Slip downloaded successfully.");
      } else {
        setLoadingSlip(false);
        toast.error("Something went wrong");
      }
      const printSlip = () => {
        const element = slipRef?.current;
        html2pdf(element, {
          margin: [2, 2, 2, 2],
          filename: `${response?.data?.data?.gli_number || ""}_Delivery Slip_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: {
            dpi: 100,
            letterRendering: true,
            useCORS: true,
            logging: true,
            scale: 4,
            scrollY: 0,
          },
          jsPDF: { unit: "mm", format: "a5", orientation: "portrait" },
          pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
          DisablePdfCompression: true,
        });
      };
      setTimeout(() => {
        printSlip();
      }, 500);
    });
  };

  const handleOrderPrintChellan = (e) => {
    setLoadingChellan(true);
    const id = e?.[0];
    getOrderPrintChellan(id).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig(
            (state) => (state.printChellanData = response?.data?.data),
          ),
        );
        toast.success("Delivery Chellan downloaded successfully.");
        setLoadingChellan(false);
      } else {
        setLoadingChellan(false);
        toast.error("Something went wrong");
      }
      let gliData = deliveryList?.data?.data?.find((item) => item?.id === id);
      const printSlip = () => {
        const element = chellanRef?.current;
        html2pdf(element, {
          margin: [10, 2, 2, 2],
          filename: `${gliData?.gli_number || ""}_Delivery Challan_${gliData?.challan_number || ""}_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: {
            dpi: 100,
            letterRendering: true,
            useCORS: true,
            logging: true,
            scale: 4,
            scrollY: 0,
          },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
          DisablePdfCompression: true,
        });
      };
      setTimeout(() => {
        printSlip();
      }, 500);
    });
  };

  const handleSelect = (rows) => {
    if (activeTab === "recheck") {
      setSelectedSlipIds(rows);
    }
    setSelectedRows(rows);
  };
  const handleStockReceiptPrint = () => {
    if (!selectedRows?.length) {
      toast.error("Please select a row first");
      return;
    }
    if (selectedSlipIds.length > 1) {
      toast.warn("Please select one stock receipt");
      return;
    }
    setLoadingStockReceipt(true);
    const id = selectedRows?.[0];
    const apiFn =
      activeTab === "orders"
        ? getDeliveryStockReceiptSlip(id)
        : getDeliveryRecheckReissueStockReceiptSlip(id);
    apiFn.then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig(
            (state) => (state.stockPrintData = response?.data?.data),
          ),
        );
        setLoadingStockReceipt(false);
        toast.success("Stock Invoice downloaded successfully");
      } else {
        setLoadingStockReceipt(false);
        toast.error("Something went wrong");
      }
    });
    const printInvoice = () => {
      const element = stockReceiptRef?.current;
      const gliNumber = deliveryList?.data?.data?.find(
        (item) => item?.id === id,
      )?.gli_number;
      html2pdf(element, {
        margin: [5, 2, 2, 2],
        filename: `${gliNumber}_${
          "Stock Receipt Slip" +
          moment(Date.now()).format("_MM_DD_YYYY_HH_mm_ss")
        }.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          dpi: 100,
          letterRendering: true,
          useCORS: true,
          logging: true,
          scale: 4,
          scrollY: 0,
        },
        jsPDF: { unit: "mm", format: "a5", orientation: "portrait" },
        pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
        DisablePdfCompression: true,
      })
        .from("element-to-print")
        .outputPdf()
        .get("pdf")
        .then(function (pdfObj) {
          pdfObj.autoPrint();
          window.open(pdfObj.output("bloburl"), "F");
        });
    };
    setTimeout(() => {
      printInvoice();
    }, 500);
  };

  const handleOfficeSlipPrint = () => {
    if (!selectedRows?.length) {
      toast.error("Please select a row first");
      return;
    }
    if (selectedSlipIds.length > 1) {
      toast.warn("Please select one stock receipt");
      return;
    }
    setLoadingOfficeSlip(true);
    const id = selectedRows?.[0];
    const apiFn =
      activeTab === "orders"
        ? getDeliveryStockReceiptSlip(id)
        : getDeliveryRecheckReissueStockReceiptSlip(id);
    apiFn.then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig(
            (state) => (state.stockPrintData = response?.data?.data),
          ),
        );
        setLoadingOfficeSlip(false);
        toast.success("Office Slip downloaded successfully.");
      } else {
        setLoadingOfficeSlip(false);
        toast.error("Something went wrong");
      }
    });
    const printInvoice = () => {
      const element = officeSlipRef?.current;
      const gliNumber = deliveryList?.data?.data?.find(
        (item) => item?.id === id,
      )?.gli_number;
      html2pdf(element, {
        margin: [2, 2, 2, 2],
        filename: `${gliNumber}_${
          "Office Slip" + moment(Date.now()).format("_MM_DD_YYYY_HH_mm_ss")
        }.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          dpi: 100,
          letterRendering: true,
          useCORS: true,
          logging: true,
          scale: 4,
          scrollY: 0,
        },
        jsPDF: { unit: "mm", format: "a6", orientation: "portrait" },
        pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
        DisablePdfCompression: true,
      });
    };
    setTimeout(() => {
      printInvoice();
    }, 500);
  };

  return {
    tabNavs: navigation,
    paginationOptions,
    deliveryList,
    isLoading,
    isFetching,
    tableFields,
    showEditModal,
    queryState,
    activeTab,
    date,
    handleDateChange,
    handleSearch,
    handleSort,
    handlePageSize,
    handlePagination,
    updateEstimateFields,
    handleEditColumnsClick,
    refetch,
    getRow,
    handlePrintSlip,
    handlePrintChellan,
    handleOrderPrintSlip,
    handleOrderPrintChellan,
    setSelectedSlipIds,
    slipRef,
    chellanRef,
    officeSlipRef,
    stockReceiptRef,
    loadingSlip,
    loadingChellan,
    loadingStockReceipt,
    loadingOfficeSlip,
    handleStockReceiptPrint,
    handleOfficeSlipPrint,
    handleSelect,
    selectedRows,
  };
};

export default useDeliveryCompleted;
